var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurlyVector4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 54,
    viewBox: "0 0 279 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08203 21.042C25.0768 13.345 46.4452 9.11003 70.6376 13.1531C87.3183 15.9409 107.552 20.2829 121.193 31.042C125.966 34.8062 130.23 39.0526 128.415 45.4865C128.099 46.6096 125.349 53.0336 123.082 52.042C119.156 50.3246 127.085 36.5096 128.082 35.1531C131.681 30.2584 136.085 25.7425 141.526 22.9309C158.136 14.3493 178.092 9.78282 196.36 6.70869C230.165 1.01981 266.554 0.438314 300.582 4.3198C316.659 6.15365 332.932 9.21525 348.082 15.042",
    stroke: "#FFC220",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurlyVector4);
export default __webpack_public_path__ + "static/media/curly-vector-4.46487197.svg";
export { ForwardRef as ReactComponent };